var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class PlatformJwtManager {
    constructor(tokenStorage, player, tokenValidator, requestGateway) {
        this.tokenStorage = tokenStorage;
        this.player = player;
        this.tokenValidator = tokenValidator;
        this.requestGateway = requestGateway;
    }
    getPlatformJWT() {
        const token = this.tokenStorage.getToken();
        if (!token) {
            this.player.logout();
        }
        return token;
    }
    setPlatformJWT(token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (token) {
                this.requestGateway.setToken(token);
            }
        });
    }
    hasLoggedInToken() {
        const token = this.tokenStorage.getToken();
        return token && !this.tokenValidator.isAnonymous(token);
    }
}
//# sourceMappingURL=PlatformJwtManager.js.map